import { Component } from "react";
import { ToastContainer } from "react-toastify";
import Loader from "../../../utils/Loader";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../utils/withRouter";
import { getExhibitorEntryPassDetails_action } from "../../../actions/exhibitor_module_actions/exhibitorEntryPass_action/exhibitorEntryPass_action"
import { connect } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { countryActionId, toastError, toastSuccess, exhibitorBadgeDaysActionId } from "../../../utils/constants";
import $ from 'jquery'
import moment from "moment";
import AdminHeader from '../../../common_components/admin_module_header';

class ContractorEntryPass extends Component {

    // Initialize Constructor
    constructor(props) {
        super(props)
        //States
        this.state = {
            isLoading: false,
            category: 'Exhibitor',
            itemToCarryList: [{ Name: '', Quantity: '' }],
            ContractorId: ''
        }
    }

    componentDidMount() {
        this.getExhibitorEntryPassDetails()
        this.loadscript()
    }

    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }

    handleOpenForm(ID, deadline, StatusID, name, ServiceID) {
        this.props.navigate('/manualFormsVendorList', { state: { Deadline: deadline, StatusID, ManualFormsID: ID, ManualFormsName: name, ServiceID: ServiceID } })
    }


    getExhibitorEntryPassDetails() {
        const { ContractorId } = this.state
        this.setState({ isLoading: true })
        this.props.getExhibitorEntryPassDetails_action(ContractorId)
            .then((data) => {
                if (data.error != 1) {
                    if (data.data.length > 0) {
                        this.setState({ isLoading: false, })
                    }
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            }).catch((err) => {
                console.log(err)
            })
        setTimeout(() => {
            console.log(this.state.List)
        }, 200);
    }

    getRandomLightColor() {
        const hue = Math.floor(Math.random() * 360);       // any hue
        const saturation = 45 + Math.random() * 15;        // 45–60% saturation (soft colors)
        const lightness = 78 + Math.random() * 7;          // 78–85% lightness (slightly lighter)
        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    }

    handleInput = async (e, type, field, index) => {
        const updatedList = structuredClone(this.state.itemToCarryList)
        let Value;

        if (type === 'date') {
            Value = e;
        } else if (type === 'int') {
            Value = e.target.value.replace(/\D/g, '');
        } else if (type === 'checkbox') {
            Value = e.target.checked;
        } else if (type === 'file') {
            Value = e.target.files;
        } else {
            Value = e.target.value;
        }

        // --- Subcontractor level update ---
        updatedList[index][field] = Value;

        this.setState({ itemToCarryList: updatedList });
    };

    removeItem(index) {
        const { itemToCarryList } = this.state
        const filterArray = itemToCarryList.filter((item, i) => i != index)
        if (filterArray.length == 0) {
            filterArray.push({ Name: '', Quantity: '' })
        }
        console.log("filterArray---->", filterArray)
        this.setState({ itemToCarryList: filterArray })
    }

    render() {
        const { isLoading, category, itemToCarryList } = this.state
        // console.log("List------------->", List)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <AdminHeader />
                {/* <ExhibitorDrawer /> */}
                {/*app-content open*/}
                <div className="page">
                    <div className="page-main">
                        <div className="main-content" style={{ marginTop: '85px' }}>
                            {/* <div className="container-fluid">
                                <div className="row">
                                    <div className="tab-scroll-fixed">
                                <p>Exhibitor Dashboard</p>
                            </div>
                                    <ExhibitorTopMenu />
                                </div>
                            </div> */}

                            <div className="pagetitle">
                                <nav>
                                    <ol className=" breadcrumb border-bottom pb-2 mb-0 d-flex justify-content-between align-items-center  p-2">
                                        <li className="breadcrumb-item active fw-bolder mb-0 bg-white pl-2">
                                            Contractor Material Entry pass
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            <section className="p-3 text-left">
                                <div className="row m-0">
                                    <div className="col-md-8 p-0">
                                        <div className="row pb-0">
                                            <div className="col-md-4 mb-2">
                                                <label className="text-muted d-block fw-normal">
                                                    Exhibitor Name
                                                </label>
                                                <span className="fw-semibold">ABC Exhibitions Pvt. Ltd.</span>
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <label className="text-muted d-block fw-normal">
                                                    Hall No / Booth No
                                                </label>
                                                <span className="fw-semibold">Hall 1 / B-12</span>
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <label className="text-muted d-block fw-normal">
                                                    Contact Person
                                                </label>
                                                <span className="fw-semibold">Mr. Rajesh Sharma</span>
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <label className="text-muted d-block fw-normal">Mobile</label>
                                                <span className="fw-semibold">+91 98765 43210</span>
                                            </div>
                                            <div className="col-md-4 mb-2">
                                                <label className="text-muted d-block fw-normal">Email</label>
                                                <span className="fw-semibold">rajesh.sharma@abcexpo.com</span>
                                            </div>
                                            {/* <div class="col-md-4 mb-2">
        <label class="text-muted d-block fw-normal">Date</label>
        <span class="fw-semibold">22/09/2025</span>
      </div> */}
                                        </div>
                                    </div>
                                    <div className="col-md-4 text-center">
                                        <img
                                            src="images/no-dues-issued.png"
                                            className="img-responsive m-auto d-block"
                                            style={{ width: 150 }}
                                        />
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="form-group py-3 pt-1 pb-2 m-0">
                                        <label className="form-label d-block mb-2 fw-bold">
                                            Select Category
                                        </label>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input mt-1"
                                                type="radio"
                                                name="userType"
                                                id="exhibitor"
                                                checked={category == 'Exhibitor'}
                                                onChange={() => this.setState({ category: 'Exhibitor' })}
                                            />
                                            <label className="form-check-label" htmlFor="exhibitor">
                                                Exhibitor
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input mt-1"
                                                type="radio"
                                                name="userType"
                                                id="contractor"
                                                checked={category == 'contractor'}
                                                onChange={() => this.setState({ category: 'contractor' })}
                                            />
                                            <label className="form-check-label" htmlFor="contractor">
                                                Contractor
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="select-details">
                                    <div className="accordion w-100" id="entryAccordion">
                                        <div className="accordion-item border-0">
                                            <h2
                                                className="accordion-header"
                                                id="headingOne"
                                                style={{ position: "relative" }}
                                            >
                                                <button
                                                    className="accordion-button collapsed d-flex align-items-center justify-content-between p-1 border rounded-0"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapseOne"
                                                    aria-expanded="false"
                                                    aria-controls="collapseOne"
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <span className="text-muted  px-2 border-end fw-bold">
                                                            <i className="fa fa-calendar-o me-1 text-dark" />
                                                            28 Sep 2025
                                                        </span>
                                                        <span className="text-muted  px-2 border-end pt-1">
                                                            <i className="bi bi-door-closed-fill me-1 " />
                                                            Entry No: ITME2026/EN/0000002
                                                        </span>
                                                        <span className="text-muted px-2 border-end fw-normal">
                                                            <i className="ri-hotel-line me-1 text-dark" />
                                                            Golden Horizon Pvt Ltd
                                                        </span>
                                                        <span className="text-muted px-2 border-end fw-normal">
                                                            <i className="ri-phone-line me-1 text-dark" />
                                                            9876543210
                                                        </span>
                                                        <span className=" px-2 fw-normal">
                                                            <i className="ri-mail-line me-1 text-dark" />
                                                            ram@mail.com
                                                        </span>
                                                    </div>
                                                    {/* Action icons */}
                                                </button>
                                                <div className="d-flex align-items-center mx-2 icon-header ">
                                                    <i
                                                        className="ri-download-line fs-6 grid-icon p-1 rounded-1 px-2 fw-normal"
                                                        title="download Material Entry pass"
                                                    />
                                                    <i
                                                        className="ri-printer-line fs-6 grid-icon p-1 rounded-1 px-2 fw-normal"
                                                        title="Print Material Entry pass"
                                                    />
                                                    <i
                                                        className="fa fa-qrcode fs-6 grid-icon p-1 rounded-1 px-2 fw-normal qrIcon"
                                                        title="Scan to Print"
                                                    />
                                                </div>
                                            </h2>
                                            <div
                                                id="collapseOne"
                                                className="accordion-collapse collapse"
                                                aria-labelledby="headingOne"
                                            >
                                                <div className="accordion-body p-0">
                                                    <div className="card-body p-1">
                                                        <div className="d-flex justify-content-between align-items-center pt-0 pb-1"></div>
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-sm mb-0">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th style={{ width: 60, textAlign: "center" }}>
                                                                            Sr. No.
                                                                        </th>
                                                                        <th>Item Name</th>
                                                                        <th style={{ width: 80, textAlign: "center" }}>Qty</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="text-center">1</td>
                                                                        <td>LED Monitor</td>
                                                                        <td className="text-center">2</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">2</td>
                                                                        <td>CPU</td>
                                                                        <td className="text-center">1</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">3</td>
                                                                        <td>Brochures</td>
                                                                        <td className="text-center">200</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">4</td>
                                                                        <td>Textile Fabric Samples</td>
                                                                        <td className="text-center">50</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">5</td>
                                                                        <td>Roll-up Standee</td>
                                                                        <td className="text-center">3</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">6</td>
                                                                        <td>Catalog Books</td>
                                                                        <td className="text-center">100</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">7</td>
                                                                        <td>Chair</td>
                                                                        <td className="text-center">4</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">8</td>
                                                                        <td>Table</td>
                                                                        <td className="text-center">2</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">9</td>
                                                                        <td>Lighting Kit</td>
                                                                        <td className="text-center">5</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">10</td>
                                                                        <td>Sample Garments</td>
                                                                        <td className="text-center">30</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item mt-2 border-0">
                                            <h2
                                                className="accordion-header"
                                                id="headingTwo"
                                                style={{ position: "relative" }}
                                            >
                                                <button
                                                    className="accordion-button collapsed d-flex align-items-center justify-content-between p-1 border"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapseTwo"
                                                    aria-expanded="false"
                                                    aria-controls="collapseTwo"
                                                >
                                                    {/* Header details with borders */}
                                                    <div className="d-flex align-items-center">
                                                        <span className="text-muted  px-2 border-end fw-bold">
                                                            <i className="fa fa-calendar-o me-1 text-dark" />
                                                            26 Sep 2025
                                                        </span>
                                                        <span className="text-muted  px-2 border-end pt-1">
                                                            <i className="bi bi-door-closed-fill me-1 " />
                                                            Entry No: ITME2026/EN/0000001
                                                        </span>
                                                        <span className="text-muted px-2 border-end fw-normal">
                                                            <i className="ri-hotel-line me-1 text-dark" />
                                                            Bluepeak Pvt Ltd
                                                        </span>
                                                        <span className="text-muted px-2 border-end fw-normal">
                                                            <i className="ri-phone-line me-1 text-dark" />
                                                            9876543210
                                                        </span>
                                                        <span className=" px-2 fw-normal">
                                                            <i className="ri-mail-line me-1 text-dark" />
                                                            sagar@mail.com
                                                        </span>
                                                    </div>
                                                    {/* Action icons */}
                                                </button>
                                                <div className="d-flex align-items-center mx-2 icon-header mt-1">
                                                    <i
                                                        className="ri-download-line fs-6 grid-icon p-1 rounded-1 px-2 fw-normal"
                                                        title="download Material Entry pass"
                                                    />
                                                    <i
                                                        className="ri-printer-line fs-6 grid-icon p-1 rounded-1 px-2 fw-normal"
                                                        title="Print Material Entry pass"
                                                    />
                                                    <i
                                                        className="fa fa-qrcode fs-6 grid-icon p-1 rounded-1 px-2 fw-normal qrIcon"
                                                        title="Scan to Print"
                                                    />
                                                </div>
                                            </h2>
                                            <div
                                                id="collapseTwo"
                                                className="accordion-collapse collapse"
                                                aria-labelledby="headingTwo"
                                            >
                                                <div className="accordion-body p-0">
                                                    <div className="card-body p-1">
                                                        <div className="d-flex justify-content-between align-items-center pt-0 pb-1"></div>
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-sm mb-0">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th style={{ width: 60, textAlign: "center" }}>
                                                                            Sr. No.
                                                                        </th>
                                                                        <th>Item Name</th>
                                                                        <th style={{ width: 80, textAlign: "center" }}>Qty</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="text-center">1</td>
                                                                        <td>LED Monitor</td>
                                                                        <td className="text-center">2</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">2</td>
                                                                        <td>CPU</td>
                                                                        <td className="text-center">1</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">3</td>
                                                                        <td>Brochures</td>
                                                                        <td className="text-center">200</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">4</td>
                                                                        <td>Textile Fabric Samples</td>
                                                                        <td className="text-center">50</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">5</td>
                                                                        <td>Roll-up Standee</td>
                                                                        <td className="text-center">3</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">6</td>
                                                                        <td>Catalog Books</td>
                                                                        <td className="text-center">100</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">7</td>
                                                                        <td>Chair</td>
                                                                        <td className="text-center">4</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">8</td>
                                                                        <td>Table</td>
                                                                        <td className="text-center">2</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">9</td>
                                                                        <td>Lighting Kit</td>
                                                                        <td className="text-center">5</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">10</td>
                                                                        <td>Sample Garments</td>
                                                                        <td className="text-center">30</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item mt-2 border-0">
                                            <h2
                                                className="accordion-header"
                                                id="headingThree"
                                                style={{ position: "relative" }}
                                            >
                                                <button
                                                    className="accordion-button collapsed d-flex align-items-center justify-content-between p-1 border"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapseThree"
                                                    aria-expanded="false"
                                                    aria-controls="collapseThree"
                                                >
                                                    {/* Header details with borders */}
                                                    <div className="d-flex align-items-center">
                                                        <span className="text-muted  px-2 border-end fw-bold">
                                                            <i className="fa fa-calendar-o me-1 text-dark" />
                                                            25 Sep 2025
                                                        </span>
                                                        <span className="text-muted  px-2 border-end pt-1">
                                                            <i className="bi bi-door-closed-fill me-1 " />
                                                            Entry No: ITME2026/EN/0000003
                                                        </span>
                                                        <span className="text-muted px-2 border-end fw-normal">
                                                            <i className="ri-hotel-line me-1 text-dark" />
                                                            Silverline Pvt Ltd
                                                        </span>
                                                        <span className="text-muted px-2 border-end fw-normal">
                                                            <i className="ri-phone-line me-1 text-dark" />
                                                            9876543210
                                                        </span>
                                                        <span className=" px-2 fw-normal">
                                                            <i className="ri-mail-line me-1 text-dark" />
                                                            nihal@mail.com
                                                        </span>
                                                    </div>
                                                    {/* Action icons */}
                                                </button>
                                                <div className="d-flex align-items-center mx-2 icon-header mt-1">
                                                    <i
                                                        className="ri-download-line fs-6 grid-icon p-1 rounded-1 px-2 fw-normal"
                                                        title="download Material Entry pass"
                                                    />
                                                    <i
                                                        className="ri-printer-line fs-6 grid-icon p-1 rounded-1 px-2 fw-normal"
                                                        title="Print Material Entry pass"
                                                    />
                                                    <i
                                                        className="fa fa-qrcode fs-6 grid-icon p-1 rounded-1 px-2 fw-normal qrIcon"
                                                        title="Scan to Print"
                                                    />
                                                </div>
                                            </h2>
                                            <div
                                                id="collapseThree"
                                                className="accordion-collapse collapse"
                                                aria-labelledby="headingThree"
                                            >
                                                <div className="accordion-body p-0">
                                                    <div className="card-body p-1">
                                                        <div className="d-flex justify-content-between align-items-center pt-0 pb-1"></div>
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-sm mb-0">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th style={{ width: 60, textAlign: "center" }}>
                                                                            Sr. No.
                                                                        </th>
                                                                        <th>Item Name</th>
                                                                        <th style={{ width: 80, textAlign: "center" }}>Qty</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="text-center">1</td>
                                                                        <td>LED Monitor</td>
                                                                        <td className="text-center">2</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">2</td>
                                                                        <td>CPU</td>
                                                                        <td className="text-center">1</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">3</td>
                                                                        <td>Brochures</td>
                                                                        <td className="text-center">200</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">4</td>
                                                                        <td>Textile Fabric Samples</td>
                                                                        <td className="text-center">50</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">5</td>
                                                                        <td>Roll-up Standee</td>
                                                                        <td className="text-center">3</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">6</td>
                                                                        <td>Catalog Books</td>
                                                                        <td className="text-center">100</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">7</td>
                                                                        <td>Chair</td>
                                                                        <td className="text-center">4</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">8</td>
                                                                        <td>Table</td>
                                                                        <td className="text-center">2</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">9</td>
                                                                        <td>Lighting Kit</td>
                                                                        <td className="text-center">5</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">10</td>
                                                                        <td>Sample Garments</td>
                                                                        <td className="text-center">30</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item mt-2 border-0">
                                            <h2
                                                className="accordion-header"
                                                id="headingFour"
                                                style={{ position: "relative" }}
                                            >
                                                <button
                                                    className="accordion-button collapsed d-flex align-items-center justify-content-between p-1 border"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapseFour"
                                                    aria-expanded="false"
                                                    aria-controls="collapseFour"
                                                >
                                                    {/* Header details with borders */}
                                                    <div className="d-flex align-items-center">
                                                        <span className="text-muted  px-2 border-end fw-bold">
                                                            <i className="fa fa-calendar-o me-1 text-dark" />
                                                            23 Sep 2025
                                                        </span>
                                                        <span className="text-muted  px-2 border-end pt-1">
                                                            <i className="bi bi-door-closed-fill me-1 " />
                                                            Entry No: ITME2026/EN/0000004
                                                        </span>
                                                        <span className="text-muted px-2 border-end fw-normal">
                                                            <i className="ri-hotel-line me-1 text-dark" />
                                                            Greenfield Pvt Ltd
                                                        </span>
                                                        <span className="text-muted px-2 border-end fw-normal">
                                                            <i className="ri-phone-line me-1 text-dark" />
                                                            9876543210
                                                        </span>
                                                        <span className=" px-2 fw-normal">
                                                            <i className="ri-mail-line me-1 text-dark" />
                                                            shiv@mail.com
                                                        </span>
                                                    </div>
                                                    {/* Action icons */}
                                                </button>
                                                <div className="d-flex align-items-center mx-2 icon-header mt-1">
                                                    <i
                                                        className="ri-download-line fs-6 grid-icon p-1 rounded-1 px-2 fw-normal"
                                                        title="download Material Entry pass"
                                                    />
                                                    <i
                                                        className="ri-printer-line fs-6 grid-icon p-1 rounded-1 px-2 fw-normal"
                                                        title="Print Material Entry pass"
                                                    />
                                                    <i
                                                        className="fa fa-qrcode fs-6 grid-icon p-1 rounded-1 px-2 fw-normal qrIcon"
                                                        title="Scan to Print"
                                                    />
                                                </div>
                                            </h2>
                                            <div
                                                id="collapseFour"
                                                className="accordion-collapse collapse"
                                                aria-labelledby="headingFour"
                                            >
                                                <div className="accordion-body p-0">
                                                    <div className="card-body p-1">
                                                        <div className="d-flex justify-content-between align-items-center pt-0 pb-1"></div>
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-sm mb-0">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th style={{ width: 60, textAlign: "center" }}>
                                                                            Sr. No.
                                                                        </th>
                                                                        <th>Item Name</th>
                                                                        <th style={{ width: 80, textAlign: "center" }}>Qty</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="text-center">1</td>
                                                                        <td>LED Monitor</td>
                                                                        <td className="text-center">2</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">2</td>
                                                                        <td>CPU</td>
                                                                        <td className="text-center">1</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">3</td>
                                                                        <td>Brochures</td>
                                                                        <td className="text-center">200</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">4</td>
                                                                        <td>Textile Fabric Samples</td>
                                                                        <td className="text-center">50</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">5</td>
                                                                        <td>Roll-up Standee</td>
                                                                        <td className="text-center">3</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">6</td>
                                                                        <td>Catalog Books</td>
                                                                        <td className="text-center">100</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">7</td>
                                                                        <td>Chair</td>
                                                                        <td className="text-center">4</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">8</td>
                                                                        <td>Table</td>
                                                                        <td className="text-center">2</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">9</td>
                                                                        <td>Lighting Kit</td>
                                                                        <td className="text-center">5</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">10</td>
                                                                        <td>Sample Garments</td>
                                                                        <td className="text-center">30</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mx-0 mt-2">
                                        <div className="card border-warning mb-2 shadow-none p-0 border">
                                            <div className="card-header bg-warning text-dark py-2 fw-bold">
                                                <i className="bi bi-exclamation-circle-fill me-2" />
                                                Important Notes
                                            </div>
                                            <div className="card-body py-3 p-0">
                                                <ol className="mb-0">
                                                    <li className="mb-2">
                                                        Kindly submit the <strong> Material Entry pass </strong> in{" "}
                                                        <strong>one copies </strong>as follows:
                                                        <ul className="mb-0" type='circle'>
                                                            {/* <li><strong>1 copy</strong> to the respective <strong> Hall Manager</strong></li> */}
                                                            <li>
                                                                <strong>1 copy</strong> to the{" "}
                                                                <strong>Venue Main Gate Security</strong>
                                                            </li>
                                                            {/* <li><strong>1 copy</strong> to be <strong>retained by the exhibitor</strong> for reference and
              transport purposes</li> */}
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        Exhibitors/contractors are required to carry their Material Entry pass at
                                                        all times for verification.
                                                    </li>
                                                    <li className="py-2">
                                                        Entry without a valid Material Entry pass will not be permitted.
                                                    </li>
                                                    <li>
                                                        Materials and exhibits brought inside the venue must follow the
                                                        guidelines and checks mentioned in the Exhibitor Manual.
                                                    </li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mx-0">
                                        <div className="card border-info mb-1 border shadow-none p-0">
                                            <div className="card-header bg-info text-white fw-bold py-2">
                                                <i className="bi bi-box-seam me-2" />
                                                Items to Carry
                                            </div>
                                            <div className="card-body px-2 pb-2">
                                                <p className="pt-2 fw-bold">
                                                    Please list the items (bags, cartons, packages, etc.) you wish to
                                                    carry in the exhibition:
                                                </p>
                                                <div className="table-responsive ">
                                                    <table
                                                        className="table table-bordered table-sm mb-2"
                                                        id="itemsTable1"
                                                    >
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th style={{ width: 60, textAlign: "center" }}>Sr. No.</th>
                                                                <th>Item Name</th>
                                                                <th style={{ width: 80, textAlign: "center" }}>Qty</th>
                                                                <th style={{ width: 60, textAlign: "center" }}>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {itemToCarryList.length > 0 && itemToCarryList.map((item, i) => (
                                                                <tr>
                                                                    <td className="text-center">{i + 1}</td>
                                                                    <td>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-sm w-100"
                                                                            placeholder="Enter item"
                                                                            maxLength={200}
                                                                            value={item.Name}
                                                                            onChange={(e) => this.handleInput(e, 'varchar', 'Name', i)}
                                                                        />
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm w-100 text-center"
                                                                            placeholder={0}
                                                                            maxLength={10}
                                                                            value={item.Quantity}
                                                                            onChange={(e) => this.handleInput(e, 'int', 'Quantity', i)}
                                                                        />
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-sm"
                                                                            onClick={(e) => this.removeItem(i)}
                                                                        >
                                                                            <i className="bi bi-trash text-danger" />
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))}

                                                        </tbody>
                                                    </table>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-info"
                                                    onClick={() => {
                                                        const updatedList = [...this.state.itemToCarryList];
                                                        updatedList.push({
                                                            Name: '',
                                                            Quantity: '',
                                                        });
                                                        this.setState({ itemToCarryList: updatedList });
                                                    }}
                                                >
                                                    <i className="bi bi-plus-circle me-1" /> Add More Items
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="select-contractor" style={{ display: "none" }}>
                                    <div className=" align-items-end w-100 mb-2">
                                        <div className="col-md-2">
                                            <select id="companySelect" className="form-select form-select-sm">
                                                <option>ABC Exhibitions Pvt Ltd - Water</option>
                                                <option>Techno Systems Pvt Ltd - Water</option>
                                                <option>Sunshine Pvt Ltd - Power</option>
                                                <option>Alpha Robotics Ltd - Security</option>
                                                <option value="Others">Others</option>
                                            </select>
                                        </div>
                                        {/* Hidden input (appears only when 'Others' is selected) */}
                                        <div id="otherInput" className="mt-2" style={{ display: "none" }}>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm w-100"
                                                        placeholder="Enter Company Name"
                                                    />
                                                </div>
                                                <div className="col-md-3">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm w-100"
                                                        placeholder="Enter Mobile NO"
                                                    />
                                                </div>
                                                <div className="col-md-3">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm w-100"
                                                        placeholder="Enter Email"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion" id="entryAccordion">
                                        <div className="accordion-item border-0">
                                            <h2
                                                className="accordion-header"
                                                id="headingOne"
                                                style={{ position: "relative" }}
                                            >
                                                <button
                                                    className="accordion-button collapsed d-flex align-items-center justify-content-between p-1 border rounded-0"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapseOne"
                                                    aria-expanded="false"
                                                    aria-controls="collapseOne"
                                                >
                                                    {/* Header details with borders */}
                                                    <div className="d-flex align-items-center">
                                                        <span className="text-muted  px-2 border-end fw-bold">
                                                            <i className="fa fa-calendar-o me-1 text-dark" />
                                                            28 Sep 2025
                                                        </span>
                                                        <span className="text-muted  px-2 border-end pt-1">
                                                            <i className="bi bi-door-closed-fill me-1 " />
                                                            Entry No: ITME2026/EN/0000002
                                                        </span>
                                                        <span className="text-muted px-2 border-end fw-normal">
                                                            <i className="ri-hotel-line me-1 text-dark" />
                                                            Bluepeak Pvt Ltd
                                                        </span>
                                                        <span className="text-muted px-2 border-end fw-normal">
                                                            <i className="ri-phone-line me-1 text-dark" />
                                                            9876543210
                                                        </span>
                                                        <span className=" px-2 fw-normal">
                                                            <i className="ri-mail-line me-1 text-dark" />
                                                            ram@mail.com
                                                        </span>
                                                    </div>
                                                    {/* Action icons */}
                                                </button>
                                                <div className="d-flex align-items-center mx-2 icon-header mt-1">
                                                    <i
                                                        className="ri-download-line fs-6 grid-icon p-1 rounded-1 px-2 fw-normal"
                                                        title="download Material Entry pass"
                                                    />
                                                    <i
                                                        className="ri-printer-line fs-6 grid-icon p-1 rounded-1 px-2 fw-normal"
                                                        title="Print Material Entry pass"
                                                    />
                                                    <i
                                                        className="fa fa-qrcode fs-6 grid-icon p-1 rounded-1 px-2 fw-normal qrIcon"
                                                        title="Scan to Print"
                                                    />
                                                </div>
                                            </h2>
                                            <div
                                                id="collapseOne"
                                                className="accordion-collapse collapse"
                                                aria-labelledby="headingOne"
                                            >
                                                <div className="accordion-body p-0">
                                                    <div className="card-body p-1">
                                                        <div className="d-flex justify-content-between align-items-center pt-0 pb-1"></div>
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-sm mb-0">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th style={{ width: 60, textAlign: "center" }}>
                                                                            Sr. No.
                                                                        </th>
                                                                        <th>Item Name</th>
                                                                        <th style={{ width: 80, textAlign: "center" }}>Qty</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="text-center">1</td>
                                                                        <td>LED Monitor</td>
                                                                        <td className="text-center">2</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">2</td>
                                                                        <td>CPU</td>
                                                                        <td className="text-center">1</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">3</td>
                                                                        <td>Brochures</td>
                                                                        <td className="text-center">200</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">4</td>
                                                                        <td>Textile Fabric Samples</td>
                                                                        <td className="text-center">50</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">5</td>
                                                                        <td>Roll-up Standee</td>
                                                                        <td className="text-center">3</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">6</td>
                                                                        <td>Catalog Books</td>
                                                                        <td className="text-center">100</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">7</td>
                                                                        <td>Chair</td>
                                                                        <td className="text-center">4</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">8</td>
                                                                        <td>Table</td>
                                                                        <td className="text-center">2</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">9</td>
                                                                        <td>Lighting Kit</td>
                                                                        <td className="text-center">5</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">10</td>
                                                                        <td>Sample Garments</td>
                                                                        <td className="text-center">30</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item mt-2 border-0">
                                            <h2
                                                className="accordion-header"
                                                id="headingTwo"
                                                style={{ position: "relative" }}
                                            >
                                                <button
                                                    className="accordion-button collapsed d-flex align-items-center justify-content-between p-1 border"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapseTwo"
                                                    aria-expanded="false"
                                                    aria-controls="collapseTwo"
                                                >
                                                    {/* Header details with borders */}
                                                    <div className="d-flex align-items-center">
                                                        <span className="text-muted  px-2 border-end fw-bold">
                                                            <i className="fa fa-calendar-o me-1 text-dark" />
                                                            26 Sep 2025
                                                        </span>
                                                        <span className="text-muted  px-2 border-end pt-1">
                                                            <i className="bi bi-door-closed-fill me-1 " />
                                                            Entry No: ITME2026/EN/0000001
                                                        </span>
                                                        <span className="text-muted px-2 border-end fw-normal">
                                                            <i className="ri-hotel-line me-1 text-dark" />
                                                            Sunshine Pvt Ltd
                                                        </span>
                                                        <span className="text-muted px-2 border-end fw-normal">
                                                            <i className="ri-phone-line me-1 text-dark" />
                                                            9876543210
                                                        </span>
                                                        <span className=" px-2 fw-normal">
                                                            <i className="ri-mail-line me-1 text-dark" />
                                                            ram@mail.com
                                                        </span>
                                                    </div>
                                                    {/* Action icons */}
                                                </button>
                                                <div className="d-flex align-items-center mx-2 icon-header mt-1">
                                                    <i
                                                        className="ri-download-line fs-6 grid-icon p-1 rounded-1 px-2 fw-normal"
                                                        title="download Material Entry pass"
                                                    />
                                                    <i
                                                        className="ri-printer-line fs-6 grid-icon p-1 rounded-1 px-2 fw-normal"
                                                        title="Print Material Entry pass"
                                                    />
                                                    <i
                                                        className="fa fa-qrcode fs-6 grid-icon p-1 rounded-1 px-2 fw-normal qrIcon"
                                                        title="Scan to Print"
                                                    />
                                                </div>
                                            </h2>
                                            <div
                                                id="collapseTwo"
                                                className="accordion-collapse collapse"
                                                aria-labelledby="headingTwo"
                                            >
                                                <div className="accordion-body p-0">
                                                    <div className="card-body p-1">
                                                        <div className="d-flex justify-content-between align-items-center pt-0 pb-1"></div>
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-sm mb-0">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th style={{ width: 60, textAlign: "center" }}>
                                                                            Sr. No.
                                                                        </th>
                                                                        <th>Item Name</th>
                                                                        <th style={{ width: 80, textAlign: "center" }}>Qty</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="text-center">1</td>
                                                                        <td>LED Monitor</td>
                                                                        <td className="text-center">2</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">2</td>
                                                                        <td>CPU</td>
                                                                        <td className="text-center">1</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">3</td>
                                                                        <td>Brochures</td>
                                                                        <td className="text-center">200</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">4</td>
                                                                        <td>Textile Fabric Samples</td>
                                                                        <td className="text-center">50</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">5</td>
                                                                        <td>Roll-up Standee</td>
                                                                        <td className="text-center">3</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">6</td>
                                                                        <td>Catalog Books</td>
                                                                        <td className="text-center">100</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">7</td>
                                                                        <td>Chair</td>
                                                                        <td className="text-center">4</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">8</td>
                                                                        <td>Table</td>
                                                                        <td className="text-center">2</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">9</td>
                                                                        <td>Lighting Kit</td>
                                                                        <td className="text-center">5</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">10</td>
                                                                        <td>Sample Garments</td>
                                                                        <td className="text-center">30</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item mt-2 border-0">
                                            <h2
                                                className="accordion-header"
                                                id="headingThree"
                                                style={{ position: "relative" }}
                                            >
                                                <button
                                                    className="accordion-button collapsed d-flex align-items-center justify-content-between p-1 border"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapseThree"
                                                    aria-expanded="false"
                                                    aria-controls="collapseThree"
                                                >
                                                    {/* Header details with borders */}
                                                    <div className="d-flex align-items-center">
                                                        <span className="text-muted  px-2 border-end fw-bold">
                                                            <i className="fa fa-calendar-o me-1 text-dark" />
                                                            25 Sep 2025
                                                        </span>
                                                        <span className="text-muted  px-2 border-end pt-1">
                                                            <i className="bi bi-door-closed-fill me-1 " />
                                                            Entry No: ITME2026/EN/0000003
                                                        </span>
                                                        <span className="text-muted px-2 border-end fw-normal">
                                                            <i className="ri-hotel-line me-1 text-dark" />
                                                            Greenfield Pvt Ltd
                                                        </span>
                                                        <span className="text-muted px-2 border-end fw-normal">
                                                            <i className="ri-phone-line me-1 text-dark" />
                                                            9876543210
                                                        </span>
                                                        <span className=" px-2 fw-normal">
                                                            <i className="ri-mail-line me-1 text-dark" />
                                                            ram@mail.com
                                                        </span>
                                                    </div>
                                                    {/* Action icons */}
                                                </button>
                                                <div className="d-flex align-items-center mx-2 icon-header mt-1">
                                                    <i
                                                        className="ri-download-line fs-6 grid-icon p-1 rounded-1 px-2 fw-normal"
                                                        title="download Material Entry pass"
                                                    />
                                                    <i
                                                        className="ri-printer-line fs-6 grid-icon p-1 rounded-1 px-2 fw-normal"
                                                        title="Print Material Entry pass"
                                                    />
                                                    <i
                                                        className="fa fa-qrcode fs-6 grid-icon p-1 rounded-1 px-2 fw-normal qrIcon"
                                                        title="Scan to Print"
                                                    />
                                                </div>
                                            </h2>
                                            <div
                                                id="collapseThree"
                                                className="accordion-collapse collapse"
                                                aria-labelledby="headingThree"
                                            >
                                                <div className="accordion-body p-0">
                                                    <div className="card-body p-1">
                                                        <div className="d-flex justify-content-between align-items-center pt-0 pb-1"></div>
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-sm mb-0">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th style={{ width: 60, textAlign: "center" }}>
                                                                            Sr. No.
                                                                        </th>
                                                                        <th>Item Name</th>
                                                                        <th style={{ width: 80, textAlign: "center" }}>Qty</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="text-center">1</td>
                                                                        <td>LED Monitor</td>
                                                                        <td className="text-center">2</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">2</td>
                                                                        <td>CPU</td>
                                                                        <td className="text-center">1</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">3</td>
                                                                        <td>Brochures</td>
                                                                        <td className="text-center">200</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">4</td>
                                                                        <td>Textile Fabric Samples</td>
                                                                        <td className="text-center">50</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">5</td>
                                                                        <td>Roll-up Standee</td>
                                                                        <td className="text-center">3</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">6</td>
                                                                        <td>Catalog Books</td>
                                                                        <td className="text-center">100</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">7</td>
                                                                        <td>Chair</td>
                                                                        <td className="text-center">4</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">8</td>
                                                                        <td>Table</td>
                                                                        <td className="text-center">2</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">9</td>
                                                                        <td>Lighting Kit</td>
                                                                        <td className="text-center">5</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">10</td>
                                                                        <td>Sample Garments</td>
                                                                        <td className="text-center">30</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item mt-2 border-0">
                                            <h2
                                                className="accordion-header"
                                                id="headingFour"
                                                style={{ position: "relative" }}
                                            >
                                                <button
                                                    className="accordion-button collapsed d-flex align-items-center justify-content-between p-1 border"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapseFour"
                                                    aria-expanded="false"
                                                    aria-controls="collapseFour"
                                                >
                                                    {/* Header details with borders */}
                                                    <div className="d-flex align-items-center">
                                                        <span className="text-muted  px-2 border-end fw-bold">
                                                            <i className="fa fa-calendar-o me-1 text-dark" />
                                                            23 Sep 2025
                                                        </span>
                                                        <span className="text-muted  px-2 border-end pt-1">
                                                            <i className="bi bi-door-closed-fill me-1 " />
                                                            Entry No: ITME2026/EN/0000004
                                                        </span>
                                                        <span className="text-muted px-2 border-end fw-normal">
                                                            <i className="ri-hotel-line me-1 text-dark" />
                                                            Bluepeak Pvt Ltd
                                                        </span>
                                                        <span className="text-muted px-2 border-end fw-normal">
                                                            <i className="ri-phone-line me-1 text-dark" />
                                                            9876543210
                                                        </span>
                                                        <span className=" px-2 fw-normal">
                                                            <i className="ri-mail-line me-1 text-dark" />
                                                            ram@mail.com
                                                        </span>
                                                    </div>
                                                    {/* Action icons */}
                                                </button>
                                                <div className="d-flex align-items-center mx-2 icon-header mt-1">
                                                    <i
                                                        className="ri-download-line fs-6 grid-icon p-1 rounded-1 px-2 fw-normal"
                                                        title="download Material Entry pass"
                                                    />
                                                    <i
                                                        className="ri-printer-line fs-6 grid-icon p-1 rounded-1 px-2 fw-normal"
                                                        title="Print Material Entry pass"
                                                    />
                                                    <i
                                                        className="fa fa-qrcode fs-6 grid-icon p-1 rounded-1 px-2 fw-normal qrIcon"
                                                        title="Scan to Print"
                                                    />
                                                </div>
                                            </h2>
                                            <div
                                                id="collapseFour"
                                                className="accordion-collapse collapse"
                                                aria-labelledby="headingFour"
                                            >
                                                <div className="accordion-body p-0">
                                                    <div className="card-body p-1">
                                                        <div className="d-flex justify-content-between align-items-center pt-0 pb-1"></div>
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-sm mb-0">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th style={{ width: 60, textAlign: "center" }}>
                                                                            Sr. No.
                                                                        </th>
                                                                        <th>Item Name</th>
                                                                        <th style={{ width: 80, textAlign: "center" }}>Qty</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="text-center">1</td>
                                                                        <td>LED Monitor</td>
                                                                        <td className="text-center">2</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">2</td>
                                                                        <td>CPU</td>
                                                                        <td className="text-center">1</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">3</td>
                                                                        <td>Brochures</td>
                                                                        <td className="text-center">200</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">4</td>
                                                                        <td>Textile Fabric Samples</td>
                                                                        <td className="text-center">50</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">5</td>
                                                                        <td>Roll-up Standee</td>
                                                                        <td className="text-center">3</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">6</td>
                                                                        <td>Catalog Books</td>
                                                                        <td className="text-center">100</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">7</td>
                                                                        <td>Chair</td>
                                                                        <td className="text-center">4</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">8</td>
                                                                        <td>Table</td>
                                                                        <td className="text-center">2</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">9</td>
                                                                        <td>Lighting Kit</td>
                                                                        <td className="text-center">5</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="text-center">10</td>
                                                                        <td>Sample Garments</td>
                                                                        <td className="text-center">30</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mx-0 mt-2">
                                        <div className="card border-warning mb-2 shadow-none p-0 border">
                                            <div className="card-header bg-warning text-dark py-2 fw-bold">
                                                <i className="bi bi-exclamation-circle-fill me-2" />
                                                Important Notes
                                            </div>
                                            <div className="card-body py-3 p-0">
                                                <ol className="mb-0">
                                                    <li className="mb-2">
                                                        Kindly submit the <strong> Material Entry pass </strong> in{" "}
                                                        <strong>one copies </strong>as follows:
                                                        <ul className="mb-0">
                                                            {/* <li><strong>1 copy</strong> to the respective <strong> Hall Manager</strong></li> */}
                                                            <li>
                                                                <strong>1 copy</strong> to the{" "}
                                                                <strong>Venue Main Gate Security</strong>
                                                            </li>
                                                            {/* <li><strong>1 copy</strong> to be <strong>retained by the exhibitor</strong> for reference and
              transport purposes</li> */}
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        Exhibitors/contractors are required to carry their Material Entry pass at
                                                        all times for verification.
                                                    </li>
                                                    <li className="py-2">
                                                        Entry without a valid Material Entry pass will not be permitted.
                                                    </li>
                                                    <li>
                                                        Materials and exhibits brought inside the venue must follow the
                                                        guidelines and checks mentioned in the Exhibitor Manual.
                                                    </li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mx-0">
                                        <div className="card border-info mb-1 border shadow-none p-0">
                                            <div className="card-header bg-info text-white fw-bold py-2">
                                                <i className="bi bi-box-seam me-2" />
                                                Items to Carry
                                            </div>
                                            <div className="card-body px-2 pb-2">
                                                <p className="pt-2 fw-bold">
                                                    Please list the items (bags, cartons, packages, etc.) you wish to
                                                    carry in the exhibition:
                                                </p>
                                                <div className="table-responsive ">
                                                    <table
                                                        className="table table-bordered table-sm mb-2"
                                                        id="itemsTable1"
                                                    >
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th style={{ width: 60, textAlign: "center" }}>Sr. No.</th>
                                                                <th>Item Name</th>
                                                                <th style={{ width: 80, textAlign: "center" }}>Qty</th>
                                                                <th style={{ width: 60, textAlign: "center" }}>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {/* Initial 5 empty rows */}
                                                            <tr>
                                                                <td className="text-center">1</td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm w-100"
                                                                        placeholder="Enter item"
                                                                    />
                                                                </td>
                                                                <td className="text-center">
                                                                    <input
                                                                        type="number"
                                                                        className="form-control form-control-sm w-100 text-center"
                                                                        placeholder={0}
                                                                    />
                                                                </td>
                                                                <td className="text-center">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm"
                                                                        onclick="removeRow(this)"
                                                                    >
                                                                        <i className="bi bi-trash text-danger" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">2</td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm w-100"
                                                                        placeholder="Enter item"
                                                                    />
                                                                </td>
                                                                <td className="text-center">
                                                                    <input
                                                                        type="number"
                                                                        className="form-control form-control-sm w-100 text-center"
                                                                        placeholder={0}
                                                                    />
                                                                </td>
                                                                <td className="text-center">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm"
                                                                        onclick="removeRow(this)"
                                                                    >
                                                                        <i className="bi bi-trash text-danger" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">3</td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm w-100"
                                                                        placeholder="Enter item"
                                                                    />
                                                                </td>
                                                                <td className="text-center">
                                                                    <input
                                                                        type="number"
                                                                        className="form-control form-control-sm w-100 text-center"
                                                                        placeholder={0}
                                                                    />
                                                                </td>
                                                                <td className="text-center">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm"
                                                                        onclick="removeRow(this)"
                                                                    >
                                                                        <i className="bi bi-trash text-danger" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">4</td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm w-100"
                                                                        placeholder="Enter item"
                                                                    />
                                                                </td>
                                                                <td className="text-center">
                                                                    <input
                                                                        type="number"
                                                                        className="form-control form-control-sm w-100 text-center"
                                                                        placeholder={0}
                                                                    />
                                                                </td>
                                                                <td className="text-center">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm"
                                                                        onclick="removeRow(this)"
                                                                    >
                                                                        <i className="bi bi-trash text-danger" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">5</td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm w-100"
                                                                        placeholder="Enter item"
                                                                    />
                                                                </td>
                                                                <td className="text-center">
                                                                    <input
                                                                        type="number"
                                                                        className="form-control form-control-sm w-100 text-center"
                                                                        placeholder={0}
                                                                    />
                                                                </td>
                                                                <td className="text-center">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm"
                                                                        onclick="removeRow(this)"
                                                                    >
                                                                        <i className="bi bi-trash text-danger" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">6</td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm w-100"
                                                                        placeholder="Enter item"
                                                                    />
                                                                </td>
                                                                <td className="text-center">
                                                                    <input
                                                                        type="number"
                                                                        className="form-control form-control-sm w-100 text-center"
                                                                        placeholder={0}
                                                                    />
                                                                </td>
                                                                <td className="text-center">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm"
                                                                        onclick="removeRow(this, 'itemsTable1')"
                                                                    >
                                                                        <i className="bi bi-trash text-danger" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center">7</td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm w-100"
                                                                        placeholder="Enter item"
                                                                    />
                                                                </td>
                                                                <td className="text-center">
                                                                    <input
                                                                        type="number"
                                                                        className="form-control form-control-sm w-100 text-center"
                                                                        placeholder={0}
                                                                    />
                                                                </td>
                                                                <td className="text-center">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm"
                                                                        onclick="removeRow(this, 'itemsTable1')"
                                                                    >
                                                                        <i className="bi bi-trash text-danger" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-info"
                                                    onclick="addRow('itemsTable1')"
                                                >
                                                    <i className="bi bi-plus-circle me-1" /> Add More Items
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-1">
                                    <div className="col d-flex justify-content-end">
                                        <button type="button" className="btn btn-primary">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                                {/* Bootstrap Tooltip Init */}
                            </section>

                            <div
                                id="scannerModal"
                                className="modal"
                                tabIndex={-1}
                                style={{
                                    display: "none",
                                    background: "rgba(0,0,0,0.5)",
                                    position: "fixed",
                                    inset: 0,
                                    zIndex: 1050,
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                <div
                                    style={{
                                        background: "#fff",
                                        borderRadius: 8,
                                        padding: 16,
                                        width: 340,
                                        maxWidth: "95%",
                                        textAlign: "center",
                                        position: "relative"
                                    }}
                                >
                                    <button
                                        id="closeModal"
                                        style={{
                                            position: "absolute",
                                            right: 10,
                                            top: 8,
                                            border: "none",
                                            background: "none",
                                            fontSize: 18,
                                            cursor: "pointer"
                                        }}
                                    >
                                        ✕
                                    </button>
                                    <h6 className="fw-bold mb-4" style={{ marginBottom: 10 }}>
                                        Scan below QR in Kiosk Device for print
                                        <br /> <span className="text-dark fw-bold">Material Entry pass</span>
                                    </h6>
                                    <img
                                        src="imges/qr-code-url.png"
                                        alt="Barcode"
                                        style={{ width: 180, height: "auto" }}
                                    />
                                </div>
                            </div>


                        </div>
                    </div>
                </div >
            </>

        )
    }
}

export default withRouter(connect(null, { getExhibitorEntryPassDetails_action })(ContractorEntryPass));